import SqButton from '@square/glass-ui/components/sq-button';
import { computed } from '@ember/object';
export default SqButton.extend({
  classNames: ['media-block__button'],
  classNameBindings: ['mediaBlockButtonRankClass'],
  attributeBindings: ['data-test-media-block-cta'],
  mediaBlockButtonRankClass: computed('rank', function () {
    if (this.rank) {
      return `media-block__button--${this.rank}`;
    } else {
      return '';
    }
  })
});